import styled from 'styled-components';

export const PrinterCardDesign = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 24px;
  row-gap: 24px;
  column-gap: 24px;
`;
